import { render, staticRenderFns } from "./commodity.vue?vue&type=template&id=456691b6&scoped=true"
import script from "./commodity.vue?vue&type=script&lang=ts"
export * from "./commodity.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456691b6",
  null
  
)

export default component.exports